export const getAllsureInsurance = (state) => state.allsureInsurance;
